import { useApi } from './use-api-call';

export const useSearchTeamsApi = () =>
    useApi<{
        teams: AccessTeamDTO[];
        roles: AccessRoleDTO[];
        teamUsers: AccessTeamUserDTO[];
        teamRoles: AccessTeamRoleDTO[];
        allowEdit: boolean;
    }>('/manage-roles/init-role-teams');

export const useSaveTeamRolesApi = () => useApi('/manage-roles/save-team-role');
export const useDeleteRoleTeamsApi = () => useApi('/manage-roles/delete-role-team?serial={serial}');
export const useToggleAssignUserTeam = () => useApi('/manage-roles/toggle-assign-user-role-team');

export type AccessTeamRoleDTO = {
    roleId: string;
    accessTeamSerial: number;
    permissionLevel: string;
};

export type AccessTeamDTO = {
    serial: number;
    title?: string;
    isActive?: boolean;
};

export type AccessRoleDTO = { id?: string; title?: string };

export type AccessTeamUserDTO = {
    accessTeamSerial?: number;
    userName?: string;
    displayName?: string;
};
